module.exports = __webpack_public_path__ + "img/payment link star.8fe6095b.svg";